import { ReactText } from 'react';
import { toast, ToastOptions, UpdateOptions } from 'react-toastify';
import { NotificationContent } from './notification-content';

export interface NotificationServiceOptions {
    debug?: boolean;
}

export class NotificationService {

    private static instance: NotificationService;
    private options: NotificationServiceOptions = { debug: false };
    private defaultToastOptions: ToastOptions = { isLoading: false, autoClose: 3000, position: 'top-right' };
    constructor(options?: NotificationServiceOptions) {
        this.options = {...this.options, ...options};
    }

    static getInstance = () => {
        if (!this.instance) {
            this.instance = new NotificationService();
        }
        return this.instance;
    };

    update = (id: ReactText, options?: UpdateOptions) => {
        if (toast.isActive(id)) {
            this.log(`notification ${id} is updated!`);
            toast.update(id, options);
        } else {
            this.log(`notification ${id} is not in use!`);
        }
    };

    notifyInfo = (message: string, options?: ToastOptions): ReactText => {
        return toast(message, {...this.defaultToastOptions, ...options, type: 'info' });
    };

    notifySuccess = (message: string, options?: ToastOptions): ReactText => {
        return toast(message, {...this.defaultToastOptions, ...options, type: 'success' });
    };

    notifyError = (message: string, options?: ToastOptions): ReactText => {
        return toast(message, {...this.defaultToastOptions, ...options, type: 'error' });
    };

    notify = (message: string, id?: ReactText, options?: ToastOptions): ReactText => {
        if (id && id !== '') {
            if (!toast.isActive(id)) {
                this.log(`notification ${id} is notified!`);
                if (message.includes('\n')) {
                    //TODO: remove this if check later. We don't want to revisit all toast message just yet.
                    return toast(NotificationContent({message}), {...options, toastId: id });
                } else {
                    return toast(message, {...options, toastId: id });
                }
            }
            this.log(`notification ${id} is already in use!`);
            return id;
        }

        this.log('Anonymous notification is notified!');
        return toast(message, {...options });
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private log = (message: string, ...args: any[]) => {
        if (this.options.debug) {
            console.log('NotificationService: ' + message, ...args);
        }
    };
}

export default NotificationService;
